// extracted by mini-css-extract-plugin
export default {"cell":"SclaViewAppCell_cell__SpRN5","btn":"SclaViewAppCell_btn__LCiG1"};